import { ApiService } from 'services';
import EnvConfig from 'env.config';

import { handleException } from 'actions/exceptions';
import { getUserConfig } from './getUserConfig';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const REMEMBER_PATH_BEFORE_LOGIN = 'REMEMBER_PATH_BEFORE_LOGIN';
export const RESTORE_PATH_AFTER_LOGIN = 'RESTORE_PATH_AFTER_LOGIN';
export const RESET_AUTH_ERROR = 'RESET_AUTH_ERROR';

function requestLogin({ login: username }) {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isFetchingUserConfig: true,
    isAuthenticated: false,
    username,
    errorMessage: null
  };
}

function receiveLogin(token) {
  return {
    type: LOGIN_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    token
  };
}

function loginError(errorMessage) {
  return {
    type: LOGIN_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    username: null,
    token: null,
    errorMessage
  };
}

function requestResetAuthError() {
  return {
    type: RESET_AUTH_ERROR,
    errorMessage: null
  };
}

export function loginUser(creds) {
  return (dispatch) => {
    dispatch(requestLogin(creds));

    const promise = () => ApiService
      .signIn(creds)
      .then((response) => {
        const { token } = response.data;
        sessionStorage.setItem(EnvConfig.firstTokenName, token);
        sessionStorage.setItem(EnvConfig.tokenName, token);
        dispatch(receiveLogin(token));
        dispatch(getUserConfig());
      })
      .catch((error) => {
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, loginError));
        }
      });
    return promise();
  };
}

export function externalLogin() {
  window.location = ApiService.getExternalLoginUrl();
}

function requestRememberPathBeforeLogin(restorePath) {
  return {
    type: REMEMBER_PATH_BEFORE_LOGIN,
    restorePath
  };
}

export function rememberPathBeforeLogin(path) {
  return dispatch => dispatch(requestRememberPathBeforeLogin(path));
}

function requestRestorePathAfterLogin() {
  return {
    type: RESTORE_PATH_AFTER_LOGIN,
    restorePath: null
  };
}

export function resetRestorePath() {
  return (dispatch) => {
    dispatch(requestRestorePathAfterLogin());
  };
}

export function resetAuthError() {
  return (dispatch) => {
    dispatch(requestResetAuthError());
  };
}
